<template>
  <div class="absolute w-full top-0 left-0">
    <div class="px-4 w-full flex h-16 relative z-50">
      <div class="w-1/2 py-2 lg:w-3/12">
        <img
          class="h-full w-auto cursor-pointer"
          src="/img/cw-logo.png"
          alt="careerwise logo"
          @click="handleMenu('home')"
        />
      </div>
      <div class="w-9/12 hidden lg:flex justify-end items-center space-x-6">
        <div
          class="hover:text-cw-alt cursor-pointer"
          @click="handleMenu('home')"
        >
          Home
        </div>
        <a
          :href="settings.central_domain_url + '/account'"
          class="btn btn-cw-700 m-0 py-3 cursor-pointer no-underline"
          >Sign in</a
        >
      </div>
      <div class="flex lg:hidden w-1/2 justify-end items-center text-cw-900">
        <svg
          v-if="menuActive"
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 cursor-pointer hover:text-cw-alt"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          @click="menuActive = !menuActive"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
        <svg
          v-if="!menuActive"
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 cursor-pointer hover:text-cw-alt"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          @click="menuActive = !menuActive"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </div>
      <div
        :class="[menuActive ? 'opacity-100' : 'opacity-0 pointer-events-none']"
        class="w-full absolute top-full left-0 mobile-menu flex space-y-8 flex-col items-center justify-center transition-all duration-100"
      >
        <div
          class="hover:text-cw-alt cursor-pointer"
          @click="handleMenu('home')"
        >
          Home
        </div>
        <a
          :href="settings.central_domain_url + '/account'"
          class="btn btn-cw-700 m-0 py-3 cursor-pointer"
          >Sign in</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus.js'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      menuActive: false,
    }
  },

  computed: {
    ...mapGetters({ settings: 'shared/getSettings' }),
  },

  methods: {
    handleMenu(item) {
      switch (item) {
        case 'home':
          if (this.$router.currentRoute.name !== 'Home') {
            this.$router.push({ name: 'Home' })
            this.$set(this, 'menuActive', false)
          }
          break
        case 'signin':
          this.showLoginModal()
          this.$set(this, 'menuActive', false)
          break
        case 'posts':
          if (this.$router.currentRoute.name !== 'Cloudposts') {
            this.$router.push({ name: 'Cloudposts' })
            this.$set(this, 'menuActive', false)
          }
          break

        default:
          break
      }
    },

    showLoginModal() {
      EventBus.$emit('toggleLoginModal')
    },

    triggerLogOut() {
      EventBus.$emit('toggleLogoutModal')
    },
  },
}
</script>

<style scoped>
.mobile-menu {
  height: calc(100vh - 4rem);
  background: rgba(255, 255, 255, 0.95);
}
</style>
